import {Component, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {ApiResponse, BaseComponent} from 'common-shared';
import {ProcessModel} from '../models/process.model';
import {NgForm} from "@angular/forms";
import {ProcessesQuery} from "../process.store";
import {SpecLinesEditComponent} from "../../../common/spec/spec-lines-edit/spec-lines-edit.component";
import {Subject} from "rxjs";

@Component({
  selector: 'mes-web-process-edit',
  templateUrl: './process-edit.component.html'
})
export class ProcessEditComponent extends BaseComponent implements OnInit {
  @Input() response: ApiResponse<any>;
  @Input() process: ProcessModel;
  @Input() wasValidated$ = new Subject<boolean>();
  @Output() changed = new EventEmitter<boolean>();
  @ViewChild(NgForm, {static: true}) form: NgForm;
  @ViewChild(SpecLinesEditComponent, {static: false}) specLinesEditComponent: SpecLinesEditComponent;

  constructor(public processesQuery: ProcessesQuery) {
    super();
  }

  ngOnInit() {
    this.form.statusChanges.subscribe(value => {
      this.changed.emit(this.form.pristine);
    });
  }

  setChanged() {
    this.form.controls.code.markAsDirty();
    this.changed.emit(this.form.pristine);
  }
}
